<template>
  <div v-cloak>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('Id'), sort: 'Id' },
            { title: $t('CreateOn'), sort: 'CreateOn' },
            { title: $t('Header'), sort: 'Header' },
            { title: $t('Contents'), sort: 'Content' },
            { title: $t('FullName'), sort: 'FullName' },
            { title: $t('Email'), sort: 'Email' },
            { title: $t('PhoneNumber'), sort: 'PhoneNumber' },
            { title: $t('OrderId'), sort: 'OrderId' },
            { title: $t('Answer'), sort: 'Answer' },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 32%">
              {{ row.id }}
            </td>
            <td style="width: 15%; direction: ltr">
              {{ row.createOn.split(" ")[0] }}<br />{{
                row.createOn.split(" ")[1]
             }}
            </td>
            <td style="width: 15%">
              {{ row.header }}
            </td>
            <td style="width: 27%">
              {{ row.content }}
            </td>
            <td style="width: 27%">
              {{ row.fullname }}
            </td>
            <td style="width: 27%">
              {{ row.emailAddress }}
            </td>
            <td style="width: 27%">
              {{ row.phone }}
            </td>
            <td style="width: 27%">
              {{ row.orderId }}
            </td>
            <td style="width: 9%">
              <vs-button
                :color="row.children[0] ? 'success':'primary'"
                :type="row.children[0] ? 'gradient':'border'"
                icon-pack="feather"
                class="bordered-btn"
                @click.prevent="onShowAnswerPopup(row)"
                v-has-permission="permission400"
                >{{ $t("Answer") }}</vs-button
              >
            </td>
          </template>
        </data-grid>
      </div>
    </div>

    <AnswerPopup
      :show="showAnswerPopup"
      @finish="onfinish"
      :AllDataForCurrentQuestion="AllDataForCurrentQuestion"
      :lastAnswer="lastAnswer"
    ></AnswerPopup>

    <modify-popup
      :show="ModifyPopup"
      :model="modalModel"
      @finish="onfinish"
      @close="closeModifyPopup"
    ></modify-popup>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import ModifyPopup from "./ModifyPopup.vue";
import AnswerPopup from "./AnswerPopup.vue";

export default {
  name: "Complaints_Index",
  components: {
    ModifyPopup,
    DataGrid,
    AnswerPopup
  },
  data() {
    return {
      permission400: "CreateForum",
      permission185: "ModifyComplaint",
      ModifyPopup: false,
      modalModel: {},
      lastAnswer:'',
      showAnswerPopup: false,
      AllDataForCurrentQuestion: {},
      gridDataSource: {
        type: "app",
        service: "CMS/api/ComplaintsQuery?status=1&",
      },
      gridSearchData: {
        keyword: "",
      },
    };
  },

  methods: {
    modifyComment(model) {
      this.modalModel = {
        id: model.id,
        comment: model.comment,
      };
      this.ModifyPopup = true;
    },
    closeModifyPopup() {
      this.ModifyPopup = false;
    },
    onfinish() {
      this.closeModifyPopup();
      this.showAnswerPopup = false;
      this.$refs.grid.renderGrid();
    },
    onShowAnswerPopup(row) {
      debugger;
      this.AllDataForCurrentQuestion = row;
      this.showAnswerPopup = true;
      if (row.children.length != 0) {
        this.lastAnswer = row.children[row.children.length - 1].content;
      } else this.lastAnswer = "";
    }
  },
};
</script>
